//JavaScript object that maps ISO 4217 currency codes to their respective currency symbols:

export const currencySymbols = {
  AED: "د.إ", // United Arab Emirates Dirham
  AFN: "؋",   // Afghan Afghani
  ALL: "Lek", // Albanian Lek
  AMD: "֏",   // Armenian Dram
  AOA: "Kz",  // Angolan Kwanza
  ARS: "$",   // Argentine Peso
  AUD: "$",   // Australian Dollar
  AWG: "ƒ",   // Aruban Florin
  AZN: "₼",   // Azerbaijani Manat
  BAM: "KM",  // Bosnia and Herzegovina Convertible Mark
  BBD: "$",   // Barbadian Dollar
  BDT: "৳",   // Bangladeshi Taka
  BGN: "лв",  // Bulgarian Lev
  BHD: ".د.ب", // Bahraini Dinar
  BIF: "Fr",  // Burundian Franc
  BMD: "$",   // Bermudian Dollar
  BND: "$",   // Brunei Dollar
  BOB: "Bs.", // Bolivian Boliviano
  BRL: "R$",  // Brazilian Real
  BSD: "$",   // Bahamian Dollar
  BTN: "Nu.", // Bhutanese Ngultrum
  BWP: "P",   // Botswanan Pula
  BYN: "Br",  // Belarusian Ruble
  BZD: "$",   // Belize Dollar
  CAD: "$",   // Canadian Dollar
  CDF: "Fr",  // Congolese Franc
  CHF: "Fr.", // Swiss Franc
  CLP: "$",   // Chilean Peso
  CNY: "¥",   // Chinese Yuan
  COP: "$",   // Colombian Peso
  CRC: "₡",   // Costa Rican Colón
  CUP: "$",   // Cuban Peso
  CVE: "$",   // Cape Verdean Escudo
  CZK: "Kč",  // Czech Koruna
  DJF: "Fdj", // Djiboutian Franc
  DKK: "kr",  // Danish Krone
  DOP: "$",   // Dominican Peso
  DZD: "د.ج", // Algerian Dinar
  EGP: "£",   // Egyptian Pound
  ERN: "Nfk", // Eritrean Nakfa
  ETB: "Br",  // Ethiopian Birr
  EUR: "€",   // Euro
  FJD: "$",   // Fijian Dollar
  FKP: "£",   // Falkland Islands Pound
  GBP: "£",   // British Pound Sterling
  GEL: "₾",   // Georgian Lari
  GHS: "₵",   // Ghanaian Cedi
  GIP: "£",   // Gibraltar Pound
  GMD: "D",   // Gambian Dalasi
  GNF: "Fr",  // Guinean Franc
  GTQ: "Q",   // Guatemalan Quetzal
  GYD: "$",   // Guyanese Dollar
  HKD: "$",   // Hong Kong Dollar
  HNL: "L",   // Honduran Lempira
  HRK: "kn",  // Croatian Kuna
  HTG: "G",   // Haitian Gourde
  HUF: "Ft",  // Hungarian Forint
  IDR: "Rp",  // Indonesian Rupiah
  ILS: "₪",   // Israeli New Shekel
  INR: "₹",   // Indian Rupee
  IQD: "ع.د", // Iraqi Dinar
  IRR: "﷼",   // Iranian Rial
  ISK: "kr",  // Icelandic Króna
  JMD: "$",   // Jamaican Dollar
  JOD: "د.ا", // Jordanian Dinar
  JPY: "¥",   // Japanese Yen
  KES: "KSh", // Kenyan Shilling
  KGS: "с",   // Kyrgyzstani Som
  KHR: "៛",   // Cambodian Riel
  KMF: "Fr",  // Comorian Franc
  KPW: "₩",   // North Korean Won
  KRW: "₩",   // South Korean Won
  KWD: "د.ك", // Kuwaiti Dinar
  KYD: "$",   // Cayman Islands Dollar
  KZT: "₸",   // Kazakhstani Tenge
  LAK: "₭",   // Laotian Kip
  LBP: "ل.ل", // Lebanese Pound
  LKR: "Rs",  // Sri Lankan Rupee
  LRD: "$",   // Liberian Dollar
  LSL: "L",   // Lesotho Loti
  LYD: "ل.د", // Libyan Dinar
  MAD: "د.م.", // Moroccan Dirham
  MDL: "L",   // Moldovan Leu
  MGA: "Ar",  // Malagasy Ariary
  MKD: "ден", // Macedonian Denar
  MMK: "K",   // Myanmar Kyat
  MNT: "₮",   // Mongolian Tugrik
  MOP: "MOP", // Macanese Pataca
  MRU: "UM",  // Mauritanian Ouguiya
  MUR: "₨",   // Mauritian Rupee
  MVR: "Rf",  // Maldivian Rufiyaa
  MWK: "MK",  // Malawian Kwacha
  MXN: "$",   // Mexican Peso
  MYR: "RM",  // Malaysian Ringgit
  MZN: "MT",  // Mozambican Metical
  NAD: "$",   // Namibian Dollar
  NGN: "₦",   // Nigerian Naira
  NIO: "C$",  // Nicaraguan Córdoba
  NOK: "kr",  // Norwegian Krone
  NPR: "रु",   // Nepalese Rupee
  NZD: "$",   // New Zealand Dollar
  OMR: "ر.ع.", // Omani Rial
  PAB: "B/.", // Panamanian Balboa
  PEN: "S/.", // Peruvian Nuevo Sol
  PGK: "K",   // Papua New Guinean Kina
  PHP: "₱",   // Philippine Peso
  PKR: "₨",   // Pakistani Rupee
  PLN: "zł",  // Polish Zloty
  PYG: "₲",   // Paraguayan Guarani
  QAR: "ر.ق", // Qatari Rial
  RON: "lei", // Romanian Leu
  RSD: "дин", // Serbian Dinar
  RUB: "₽",   // Russian Ruble
  RWF: "Fr",  // Rwandan Franc
  SAR: "﷼",   // Saudi Riyal
  SBD: "$",   // Solomon Islands Dollar
  SCR: "₨",   // Seychellois Rupee
  SDG: "ج.س.", // Sudanese Pound
  SEK: "kr",  // Swedish Krona
  SGD: "$",   // Singapore Dollar
  SHP: "£",   // Saint Helena Pound
  SLL: "Le",  // Sierra Leonean Leone
  SOS: "Sh",  // Somali Shilling
  SRD: "$",   // Surinamese Dollar
  SSP: "£",   // South Sudanese Pound
  STN: "Db",  // São Tomé and Príncipe Dobra
  SVC: "$",   // Salvadoran Colón
  SYP: "ل.س", // Syrian Pound
  SZL: "L",   // Eswatini Lilangeni
  THB: "฿",   // Thai Baht
  TJS: "SM",  // Tajikistani Somoni
  TMT: "m",   // Turkmenistani Manat
  TND: "د.ت", // Tunisian Dinar
  TOP: "T$",  // Tongan Paʻanga
  TRY: "₺",   // Turkish Lira
  TTD: "$",   // Trinidad and Tobago Dollar
  TWD: "NT$", // New Taiwan Dollar
  TZS: "Sh",  // Tanzanian Shilling
  UAH: "₴",   // Ukrainian Hryvnia
  UGX: "Sh",  // Ugandan Shilling
  USD: "$",   // United States Dollar
  UYU: "$",   // Uruguayan Peso
  UZS: "soʻm", // Uzbekistani Som
  VES: "Bs.F.", // Venezuelan Bolívar
  VND: "₫",   // Vietnamese Đồng
  VUV: "Vt",  // Vanuatu Vatu
  WST: "T",   // Samoan Tala
  XAF: "Fr",  // Central African CFA Franc
  XCD: "$",   // East Caribbean Dollar
  XOF: "Fr",  // West African CFA Franc
  XPF: "Fr",  // CFP Franc
  YER: "﷼",   // Yemeni Rial
  ZAR: "R",   // South African Rand
  ZMW: "ZK",  // Zambian Kwacha
  ZWL: "Z$",  // Zimbabwean Dollar
};
